{
  "1": ["いちがつ"],
  "2": ["にがつ"],
  "3": ["さんがつ"],
  "4": ["しがつ"],
  "5": ["ごがつ"],
  "6": ["ろくがつ"],
  "7": ["しちがつ", "なながつ"],
  "8": ["はちがつ"],
  "9": ["くがつ"],
  "10": ["じゅうがつ"],
  "11": ["じゅういちがつ"],
  "12": ["じゅうにがつ"]
}
